"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTransitionEasing = exports.defaultEasingExit = exports.defaultEasingEnter = exports.defaultTransitionDuration = exports.defaultEnterDuration = exports.defaultExitDuration = void 0;
exports.defaultExitDuration = 250;
exports.defaultEnterDuration = 250;
exports.defaultTransitionDuration = 300;
exports.defaultEasingEnter = "ease-out";
exports.defaultEasingExit = "ease-in";
exports.defaultTransitionEasing = "ease";
